module.exports = __webpack_public_path__ + "media/images/kids15-1d32944c631709a8f1d9763cd4d4302e.jpg";